/**
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，pro版只支持remixIcon图标，具体配置请查看vip群文档
 */
import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import Layout from '@/vab/layouts'
import { authentication, isHashRouterMode, publicPath } from '@/config'

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: {
      noKeepAlive: true,
      hidden: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/callback',
    name: 'Callback',
    component: () => import('@/views/callback'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/403',
    name: 'Page403',
    component: () => import('@/views/403'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/404',
    name: 'Page404',
    component: () => import('@/views/404'),
    meta: {
      hidden: true,
    },
  },
]

export const asyncRoutes = [
  {
    path: '/',
    name: 'Root',
    component: Layout,
    meta: {
      title: '首页',
      icon: 'home-2-line',
      breadcrumbHidden: true,
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index'),
        meta: {
          title: '首页',
          icon: 'home-2-line',
          noClosable: true,
        },
      },
      {
        path: 'teacher-stats',
        name: 'TeacherStatisticss',
        component: () => import('@/views/course/teacherStatistics'),
        meta: {
          title: '教练统计',
        },
      },
      {
        path: 'coupon-stats',
        name: 'CouponStatistics',
        component: () => import('@/views/coupon/couponStatistics'),
        meta: {
          title: '卡券统计',
        },
      },
      {
        path: 'group-stats',
        name: 'GroupClassStatistics',
        component: () => import('@/views/index/groupClassStatistics'),
        meta: {
          title: '团课统计',
        },
      },
      {
        path: 'private-stats',
        name: 'PrivateClassStatistics',
        component: () => import('@/views/index/privateClassStatistics'),
        meta: {
          title: '私教统计',
        },
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/index/dashboard'),
        meta: {
          title: '看板',
          icon: 'dashboard-line',
        },
      },
      {
        path: 'workbench',
        name: 'Workbench',
        component: () => import('@/views/index/workbench'),
        meta: {
          title: '工作台',
          icon: 'settings-6-line',
          dot: true,
        },
      },
      {
        path: 'couponlist',
        name: 'CouponListIndex',
        component: () => import('@/views/marketing/couponList'),
        meta: {
          noKeepAlive: true,
          title: '卡券管理',
        },
      },
      {
        path: 'couponPackage',
        name: 'CouponPackage',
        component: () => import('@/views/marketing/couponPackage'),
        meta: {
          noKeepAlive: true,
          title: '卡包管理',
        },
      },
      {
        path: 'clubCard',
        name: 'ClubCard',
        component: () => import('@/views/marketing/clubCard'),
        meta: {
          noKeepAlive: true,
          title: '健身卡',
        },
      },
      // {
      //   path: 'thirdStore',
      //   name: 'thirdStore',
      //   component: () => import('@/views/marketing/thirdStore'),
      //   meta: {
      //     noKeepAlive: true,
      //     title: '美团抖音',
      //   },
      // },
      {
        path: 'rechargeSetList',
        name: 'RechargeSetList',
        component: () => import('@/views/finance/rechargeSetList'),
        meta: {
          title: '充值套餐',
          noKeepAlive: false,
        },
      },
    ],
  },
  // 会员管理
  {
    path: '/user',
    name: 'UserManage',
    component: Layout,
    meta: {
      title: '会员',
      icon: 'user-settings-line',
    },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user'),
        meta: {
          title: '会员列表',
        },
      },
      {
        path: 'vip',
        name: 'VipList',
        component: () => import('@/views/user/vipList'),
        meta: {
          title: '会员管理',
        },
      },
      {
        path: 'feedbackManagement',
        name: 'FeedbackManagement',
        component: Layout,
        meta: {
          title: '反馈管理',
        },
        children: [
          {
            path: 'typeList',
            name: 'FeedbackTypeList',
            component: () => import('@/views/user/feedback/typeList'),
            meta: {
              title: '反馈类型',
            },
          },
          {
            path: 'feedbackList',
            name: 'FeedbackList',
            component: () => import('@/views/user/feedback/feedbackList'),
            meta: {
              title: '反馈列表',
            },
          },
        ],
      },
      {
        path: 'topAccess',
        name: 'TopAccess',
        component: () => import('@/views/user/topAccess'),
        meta: {
          title: '访问统计',
        },
      },
      {
        path: 'group',
        name: 'GroupList',
        component: () => import('@/views/user/group'),
        meta: {
          title: '用户分组',
        },
      },
      {
        path: 'batch-send-card',
        name: 'BatchSendCard',
        component: () => import('@/views/user/batchSendCard'),
        meta: {
          title: '批量发卡',
        },
      },
    ],
  },
  // 团队管理
  {
    path: '/team',
    name: 'TeamManage',
    component: Layout,
    meta: {
      title: '团队',
      icon: 'user-settings-line',
    },
    children: [
      {
        path: 'accountList',
        name: 'AccountList',
        component: () => import('@/views/user/accountList'),
        meta: {
          title: '成员列表',
        },
      },
      {
        path: 'roleList',
        name: 'RoleList',
        component: () => import('@/views/user/roleList'),
        meta: {
          title: '角色管理',
        },
      },
    ],
  },
  // 员工管理
  {
    path: '/staff',
    name: 'StaffManage',
    component: Layout,
    hidden: true,
    meta: {
      title: '员工',
      icon: 'team-line',
    },
    children: [
      {
        path: 'list',
        name: 'StaffList',
        component: () => import('@/views/staff/index'),
        meta: {
          title: '员工列表',
        },
      },
      {
        path: 'teacher',
        name: 'StaffTeacherManage',
        component: () => import('@/views/staff/teacherManage'),
        meta: {
          title: '教练管理',
        },
      },
    ],
  },
  // 财务管理
  {
    path: '/finance',
    name: 'Finance',
    component: Layout,
    meta: {
      title: '财务',
      icon: 'user-settings-line',
    },
    children: [
      {
        path: 'orderList',
        name: 'FinanceOrderList',
        component: () => import('@/views/finance/orderList'),
        meta: {
          title: '用户订单',
          icon: 'computer-line',
          // noColumn: true,
          noKeepAlive: true,
        },
      },
      {
        path: 'staffSalary',
        name: 'StaffSalary',
        component: () => import('@/views/finance/staffSalary'),
        meta: {
          title: '员工薪资',
        },
      },
      {
        path: 'orderDetail',
        name: 'FinanceOrderDetail',
        component: () => import('@/views/finance/orderDetail'),
        meta: {
          noKeepAlive: true,
          title: '订单详情',
          icon: 'computer-line',
          // noColumn: true,
        },
      },
    ],
  },
  // 配置管理
  {
    path: '/setting',
    name: 'PersonnelManagement',
    component: Layout,
    hidden: true,
    meta: {
      title: '配置',
      icon: 'user-settings-line',
      // guard: ['Admin'],
    },
    children: [
      // 产品管理
      {
        path: 'product',
        name: 'ProductManage',
        component: Layout,
        meta: {
          title: '产品',
          icon: 'function-line',
        },
        children: [
          {
            path: 'list',
            name: 'ProductList',
            component: () => import('@/views/product'),
            meta: {
              title: '产品列表',
              icon: 'computer-line',
            },
          },
          {
            path: 'detail',
            name: 'ProductDetail',
            component: () => import('@/views/product/detail'),
            meta: {
              hidden: true,
              noKeepAlive: true,
              title: '列表详情',
              icon: 'computer-line',
            },
          },
          {
            path: 'myapp',
            name: 'InstallList',
            component: () => import('@/views/product/appInstallList'),
            meta: {
              title: '已装产品',
              icon: 'computer-line',
            },
          },
          {
            path: 'installDetail',
            name: 'InstallListDetail',
            component: () => import('@/views/product/appInstallDetail'),
            meta: {
              noKeepAlive: true,
              title: '已装产品设置',
              icon: 'computer-line',
            },
          },
          {
            path: 'install',
            name: 'MyAppList',
            component: () => import('@/views/product/my'),
            meta: {
              title: '我的产品',
              icon: 'computer-line',
              noKeepAlive: true,
            },
          },
          {
            path: 'model',
            name: 'ProductModelList',
            component: () => import('@/views/product/model'),
            meta: {
              hidden: true,
              noKeepAlive: true,
              title: '型号列表',
              icon: 'computer-line',
            },
          },
          {
            path: 'aisle',
            name: 'ModelAisleList',
            component: () => import('@/views/product/aisle'),
            meta: {
              hidden: true,
              noKeepAlive: true,
              title: '货道列表',
              icon: 'computer-line',
            },
          },
        ],
      },
      {
        path: 'appInstallDetail',
        name: 'AppInstallDetail',
        component: () => import('@/views/product/appInstallDetail'),
        meta: {
          title: '应用设置',
        },
      },
      {
        path: 'personalCenter',
        name: 'PersonalCenter',
        component: () => import('@/views/setting/personalCenter'),
        meta: {
          title: '个人中心',
          icon: 'map-pin-user-line',
        },
      },
      // 设备管理
      {
        path: 'device',
        name: 'DeviceManage',
        component: Layout,
        meta: {
          title: '设备',
          icon: 'computer-line',
        },
        children: [
          {
            path: 'list',
            name: 'DeviceList',
            component: () => import('@/views/device'),
            meta: {
              title: '设备列表',
              noKeepAlive: false,
              icon: 'computer-line',
              // noColumn: true,
            },
          },
          {
            path: 'detail',
            name: 'DeviceDetail',
            component: () => import('@/views/device/detail'),
            meta: {
              hidden: true,
              noKeepAlive: true,
              title: '设备详情',
              activeMenu: '/device/list',
              icon: 'computer-line',
            },
          },
          // {
          //   path: 'placeList',
          //   name: 'PlaceList',
          //   component: () => import('@/views/device/placeList'),
          //   meta: {
          //     hidden: true,
          //     title: '地点管理',
          //     icon: 'computer-line',
          //   },
          // },
          {
            path: 'accountList',
            name: 'AccountList',
            component: () => import('@/views/device/accountList'),
            meta: {
              hidden: true,
              title: '设备账号',
            },
          },
        ],
      },
      {
        path: 'thirdStore',
        name: 'thirdStore',
        component: () => import('@/views/marketing/thirdStore'),
        meta: {
          noKeepAlive: true,
          title: '平台授权',
        },
      },
      {
        path: 'userManagement',
        name: 'UserManagement',
        component: () => import('@/views/setting/userManagement'),
        meta: {
          title: '用户管理',
          icon: 'user-3-line',
        },
      },
      {
        path: 'roleManagement',
        name: 'RoleManagement',
        component: () => import('@/views/setting/roleManagement'),
        meta: {
          title: '角色管理',
          icon: 'admin-line',
        },
      },
      {
        path: 'operationManagement',
        name: 'OperationManagement',
        component: () => import('@/views/setting/operationManagement'),
        meta: {
          title: '操作管理',
          icon: 'list-settings-line',
        },
      },
      {
        path: 'menuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/setting/menuManagement/index'),
        meta: {
          title: '菜单管理',
          icon: 'menu-2-fill',
        },
      },
      {
        path: 'sceneList',
        name: 'SceneList',
        component: () => import('@/views/device/sceneList'),
        meta: {
          hidden: true,
          title: '场景管理',
          icon: 'computer-line',
        },
      },
      {
        path: 'adminLog',
        name: 'AdminLogList',
        component: () => import('@/views/setting/log/adminLogList'),
        meta: {
          title: '操作日志',
        },
      },
      {
        path: 'principalList',
        name: 'PrincipalList',
        component: () => import('@/views/setting/principal/index'),
        meta: {
          title: '主体管理',
        },
      },
      {
        path: 'principal',
        name: 'PrincipalInfo',
        component: Layout,
        meta: {
          title: '主体信息',
        },
        children: [
          {
            path: 'baseInfo',
            name: 'PrincipalBaseInfo',
            component: () => import('@/views/setting/principal/baseInfo'),
            meta: {
              title: '基本信息',
            },
          },
          {
            path: 'store',
            name: 'PrincipalStoreManage',
            component: () => import('@/views/setting/principal/storeManage'),
            meta: {
              title: '店铺管理',
            },
          },
          {
            path: 'room',
            name: 'PrincipalRoomManage',
            component: () => import('@/views/setting/principal/roomManage'),
            meta: {
              title: '房间管理',
            },
          },
        ],
      },
      {
        path: 'dataGroup',
        name: 'DataGroup',
        component: () => import('@/views/setting/dataGroupManagement/index'),
        meta: {
          title: '数据配置',
        },
      },
      {
        path: 'pageManage',
        name: 'PageManagement',
        component: () => import('@/views/setting/pageManagement/index'),
        meta: {
          title: '页面功能',
        },
      },
      {
        path: 'questionAnswer',
        name: 'QuestionAnswerManagement',
        component: () =>
          import('@/views/setting/questionAnswerManagement/index'),
        meta: {
          title: '常见问题',
        },
      },
      {
        path: 'labelManagement',
        name: 'LabelManagement',
        component: () => import('@/views/setting/labelManagement/index'),
        meta: {
          title: '标签管理',
        },
      },
      {
        path: 'projectList',
        name: 'ProjectList',
        component: () => import('@/views/setting/project/index'),
        meta: {
          title: '项目管理',
        },
      },
    ],
  },

  // 店铺管理
  {
    path: '/marketing',
    name: 'MarketingManagement',
    component: Layout,
    hidden: true,
    meta: {
      title: '店铺',
      icon: 'user-settings-line',
    },
    children: [
      {
        path: 'coupon',
        name: 'CouponList',
        component: () => import('@/views/marketing/couponList'),
        meta: {
          noKeepAlive: true,
          title: '卡券管理',
        },
      },
      {
        path: 'couponPackage',
        name: 'CouponPackage',
        component: () => import('@/views/marketing/couponPackage'),
        meta: {
          noKeepAlive: true,
          title: '卡包管理',
        },
      },
      {
        path: 'storeList',
        name: 'StoreList',
        component: () => import('@/views/marketing/storeList'),
        meta: {
          noKeepAlive: true,
          title: '合作店铺',
        },
      },
      {
        path: 'roomList',
        name: 'RoomList',
        component: () => import('@/views/marketing/roomList'),
        meta: {
          title: '房间管理',
        },
      },
      {
        path: 'roomDetail',
        name: 'RoomDetail',
        component: () => import('@/views/marketing/roomDetail'),
        meta: {
          hidden: true,
          noKeepAlive: true,
          title: '房间详情',
        },
      },
      {
        path: 'meituanMerchantList',
        name: 'MeituanMerchantList',
        component: () => import('@/views/marketing/meituanMerchantList'),
        meta: {
          noKeepAlive: true,
          title: '美团店铺',
        },
      },
    ],
  },
  // 卡券管理
  {
    path: '/coupon',
    name: 'CouponModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '卡券',
      icon: 'coupon-line',
    },
    children: [
      {
        path: 'meituan',
        name: 'MeituanCoupon',
        component: () => import('@/views/coupon/meituanCoupon'),
        meta: {
          title: '美团卡券',
        },
      },
      {
        path: 'douyin',
        name: 'DouyinCoupon',
        component: () => import('@/views/coupon/douyinCoupon'),
        meta: {
          title: '抖音卡券',
        },
      },
      {
        path: 'store',
        name: 'StoreCoupon',
        component: () => import('@/views/coupon/storeCoupon'),
        meta: {
          title: '门店卡券',
        },
      },
      {
        path: 'package',
        name: 'StoreCouponPackage',
        component: () => import('@/views/coupon/storeCouponPackage'),
        meta: {
          title: '门店卡包',
        },
      },
      {
        path: 'user',
        name: 'UserCoupon',
        component: () => import('@/views/coupon/userCoupon'),
        meta: {
          title: '用户卡券',
        },
      },
    ],
  },
  // 运营管理
  {
    path: '/operation',
    name: 'OperationModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '运营',
      icon: 'line-chart-line',
    },
    children: [
      {
        path: 'recharge-package',
        name: 'RechargePackage',
        component: () => import('@/views/operation/rechargePackage'),
        meta: {
          title: '储值套餐',
        },
      },
      // 健身卡
      {
        path: 'card',
        name: 'OperationClubCard',
        component: () => import('@/views/operation/clubCard'),
        meta: {
          title: '健身卡',
        },
      },
      // 户外活动模块
      {
        path: 'outdoor',
        name: 'OperationOutdoorActivity',
        component: Layout,
        meta: {
          title: '户外活动',
        },
        children: [
          {
            path: 'list',
            name: 'OperationActivityList',
            component: () =>
              import('@/views/operation/outdoorActivity/activityList'),
            meta: {
              title: '活动列表',
            },
          },
          {
            path: 'type',
            name: 'OperationActivityType',
            component: () =>
              import('@/views/operation/outdoorActivity/activityType'),
            meta: {
              title: '活动类型',
            },
          },
          {
            path: 'club',
            name: 'OperationClubList',
            component: () =>
              import('@/views/operation/outdoorActivity/clubList'),
            meta: {
              title: '俱乐部',
            },
          },
        ],
      },

      {
        path: 'referral-rebate',
        name: 'ReferralRebate',
        component: () => import('@/views/operation/referralRebate'),
        meta: {
          title: '拉新返利',
        },
      },
      {
        path: 'class-coupon',
        name: 'ClassCoupon',
        component: () => import('@/views/operation/classCoupon'),
        meta: {
          title: '上课返券',
        },
      },
      {
        path: 'gift-coupon',
        name: 'GiftCoupon',
        component: () => import('@/views/operation/giftCoupon'),
        meta: {
          title: '赠送卡券',
        },
      },
      {
        path: 'member-points',
        name: 'MemberPoints',
        component: () => import('@/views/operation/memberPoints'),
        meta: {
          title: '会员积分',
        },
      },
    ],
  },
  // 课程管理
  {
    path: '/course',
    name: 'CourseModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '课程',
      icon: 'user-settings-line',
    },
    children: [
      {
        path: 'scheduling',
        name: 'CourseScheduling',
        component: () => import('@/views/course/courseScheduling'),
        meta: {
          noKeepAlive: true,
          title: '排课管理',
        },
      },
      {
        path: 'courseGroup',
        name: 'CourseGroup',
        component: () => import('@/views/course/courseCategory'),
        meta: {
          noKeepAlive: true,
          title: '课程分类',
        },
      },
      {
        path: 'courseList',
        name: 'CourseList',
        component: () => import('@/views/course/courseList'),
        meta: {
          noKeepAlive: true,
          title: '课程管理',
        },
      },
      {
        path: 'teacherStatistics',
        name: 'TeacherStatistics',
        component: () => import('@/views/course/teacherStatistics'),
        meta: {
          title: '教练统计',
        },
      },
      {
        path: 'teacher',
        name: 'TeacherList',
        component: () => import('@/views/course/TeacherList'),
        meta: {
          title: '教练管理',
        },
      },
      {
        path: 'group',
        name: 'GroupCourse',
        component: () => import('@/views/course/groupCourse'),
        meta: {
          title: '团课课程',
        },
      },
      {
        path: 'private',
        name: 'PrivateCourse',
        component: () => import('@/views/course/privateCourse'),
        meta: {
          title: '私教课程',
        },
      },
      {
        path: 'tag',
        name: 'CourseTag',
        component: () => import('@/views/course/courseTag'),
        meta: {
          title: '课程标签',
        },
      },
    ],
  },
  // 约课管理
  {
    path: '/booking',
    name: 'BookingModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '约课',
      icon: 'calendar-line',
    },
    children: [
      {
        path: 'group',
        name: 'BookGroupCourse',
        component: () => import('@/views/booking/groupCourse'),
        meta: {
          title: '团课约课',
        },
      },
      {
        path: 'private',
        name: 'BookPrivateCourse',
        component: () => import('@/views/booking/privateCourse'),
        meta: {
          title: '私教约课',
        },
      },
    ],
  },
  // 排课管理
  {
    path: '/scheduling',
    name: 'SchedulingModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '排课',
      icon: 'calendar-check-line',
    },
    children: [
      {
        path: 'group',
        name: 'GroupScheduling',
        component: () => import('@/views/scheduling/groupScheduling'),
        meta: {
          title: '团课排课',
        },
      },
      {
        path: 'private',
        name: 'PrivateScheduling',
        component: () => import('@/views/scheduling/privateScheduling'),
        meta: {
          title: '私教排课',
        },
      },
    ],
  },
  // 外部活动管理
  {
    path: '/outdoor',
    name: 'OutdoorModel',
    component: Layout,
    hidden: true,
    meta: {
      title: '活动',
    },
    children: [
      {
        path: 'activityList',
        name: 'OutdoorActivityList',
        component: () => import('@/views/outdoor/activityList'),
        meta: {
          noKeepAlive: true,
          title: '活动列表',
        },
      },
      {
        path: 'typeList',
        name: 'OutdoorActivityTypeList',
        component: () => import('@/views/outdoor/activityTypeList'),
        meta: {
          noKeepAlive: true,
          title: '活动分类',
        },
      },
      {
        path: 'clubList',
        name: 'OutdoorClubList',
        component: () => import('@/views/outdoor/clubList'),
        meta: {
          noKeepAlive: true,
          title: '俱乐部',
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    name: 'Page404',
    meta: {
      hidden: true,
    },
  },
]

const router = createRouter({
  history: isHashRouterMode
    ? createWebHashHistory(publicPath)
    : createWebHistory(publicPath),
  routes: constantRoutes,
})

function fatteningRoutes(routes) {
  return routes.flatMap((route) => {
    return route.children ? fatteningRoutes(route.children) : route
  })
}

function addRouter(routes) {
  routes.forEach((route) => {
    if (!router.hasRoute(route.name)) router.addRoute(route)
    if (route.children) addRouter(route.children)
  })
}

export function resetRouter(routes = constantRoutes) {
  routes.map((route) => {
    if (route.children) {
      route.children = fatteningRoutes(route.children)
    }
  })
  router.getRoutes().forEach((route) => {
    const routeName = route.name
    router.hasRoute(routeName) && router.removeRoute(routeName)
  })
  addRouter(routes)
}

export function setupRouter(app) {
  if (authentication === 'intelligence') addRouter(asyncRoutes)
  app.use(router)
  return router
}

export default router
